import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { Nullable, Optional } from '@src/types/utils';

import { ChatModel } from '../types';
import { ChatAccessingDialogService } from '../chat-accessing-dialog';

@Component({
  selector: 'app-chats-list',
  templateUrl: './chats-list.component.html',
  styleUrls: ['./chats-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatsListComponent implements OnChanges {
  private readonly router = inject(Router);
  private readonly chatAccessingDialog = inject(ChatAccessingDialogService);

  @Input() items: Optional<Nullable<Array<ChatModel>>>;
  @Input() selectedId: Optional<string>;
  @Output() selectedIdChange = new EventEmitter<Optional<string>>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedId']) {
      this.changeRoute(this.selectedId);
    }
  }

  onChangeSelectedId(id?: string, isChatMember?: boolean) {
    if (isChatMember) {
      this.changeRoute(id);
      this.selectedIdChange.emit(id);
    } else {
      this.chatAccessingDialog.open().subscribe();
    }
  }

  private changeRoute(chatId?: string) {
    this.router.navigate(['chats-inner', chatId || 'null']);
  }
}
